export default "__VITE_ASSET__BOO12TVC__"